import placeholderImage from '../images/placeholder.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

export const AppSpeakerCard = ({speaker}) => {
    return (
        <div className="app-speaker-card">
            <img alt={speaker.firstName + speaker.lastName} src={speaker.imageUrl ? (speaker.imageUrl.toLowerCase().startsWith('http') ? speaker.imageUrl : process.env.REACT_APP_MEDIA_URL + speaker.imageUrl) : placeholderImage} />
            <div className="app-speaker-info">
                <div className="app-speaker-name text-snippet snippet-1">
                    {speaker.firstName} {speaker.lastName}
                </div>
                <div className="app-speaker-job text-snippet snippet-1">
                    {speaker.metaData?.professions?.join(' & ')}
                </div>
            </div>
        </div>
    );
}
export const AppEventCard = ({event}) => {
    const getMonth = (date) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const m = date.getMonth();
        return months[m];
    }
    const getDay = (date) => {
        const d = date.getDate();
        return d;
    }
    const getDate = (date) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const m = date.getMonth();
        const d = date.getDate();
        const y = date.getFullYear();
        return `${months[m]} ${d}, ${y}`;
    }
    return (
        <div key={event.id} className="app-preview-event">
            <div className="app-preview-event-date-bubble">
                <div className="app-preview-event-month">
                    {getMonth(new Date(event.datetime))}
                </div>
                <div className="app-preview-event-day">
                    {getDay(new Date(event.datetime))}
                </div>
            </div>
            <div className="flex f-col a-start">
                <div className='text-snippet snippet-1 app-preview-event-title'>{event.title}</div>
                <div className='text-snippet snippet-1 app-preview-event-location'>
                    {getDate(event.datetime)} · {event.location}
                </div>
            </div>
        </div>
    );
}